import { FC, useState } from 'react';
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle
} from 'react-icons/io';
import { StyledSectionHideButtonContainer } from './styles';

interface StyledSectionHideButtonProps {
  titleSection: string;
  contentSectionContainer: JSX.Element;
}

const StyledSectionHideButton: FC<StyledSectionHideButtonProps> = ({
  titleSection,
  contentSectionContainer,
}) => {
  const [sectionOpen, setSectionOpen] = useState(false);
  return (
    <StyledSectionHideButtonContainer>
      <aside onClick={() => setSectionOpen(!sectionOpen)}>
        <p>{titleSection}</p>
        {sectionOpen ? (
          <IoIosArrowDropupCircle />
        ) : (
          <IoIosArrowDropdownCircle />
        )}
      </aside>
      {sectionOpen && contentSectionContainer}
    </StyledSectionHideButtonContainer>
  );
};

export default StyledSectionHideButton;
